import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import { CharacterLooks } from "../components/Looks/CharacterLooks";
import { Page } from "../components/Page/Page";
import Game from "../scripts/game/Game";

export function CharacterLooksPage(): JSX.Element {
  const { characterId } = useParams<{ characterId?: string }>();
  const navigate = useNavigate();

  // Use characterId from URL params, or fall back to the selected character, or use a default
  const finalCharacterId =
    characterId || Game.Core?.PlayerOptions?.SelectedCharacterId || "default";

  const handleComplete = () => {
    // Navigate back to character upgrade page
    navigate(-1); // Go back to previous page
  };

  return (
    <Page>
      <div style={{ minHeight: "100vh", backgroundColor: "#171f2a" }}>
        <CharacterLooks
          characterId={finalCharacterId}
          onComplete={handleComplete}
        />
      </div>
    </Page>
  );
}
